import { useContext } from 'react';
import UserContext from '../context/UserContext/UserContext';
import ChatbotContext from '../context/ChatbotContext/ChatbotContext';

const useEffectiveOrganisationId = (): number | null => {
  const { user } = useContext(UserContext);
  const { currentChatbot, selectedOrganisation } = useContext(ChatbotContext);

  if (!user) return null;

  return (
    selectedOrganisation?.id ??
    currentChatbot?.organisationId ??
    user.organisationId
  );
};

export default useEffectiveOrganisationId;
